import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4" data-testid="not-found-page">
      <Seo
        title="Page Not Found | CBAIQ"
        description="The page you are looking for does not exist."
        path="/404"
        noindex
      />
      <h1 className="font-heading text-5xl font-semibold text-foreground mb-4">404</h1>
      <p className="text-muted-foreground mb-8">This page doesn't exist or has been moved.</p>
      <Link to="/">
        <Button data-testid="not-found-home-btn">Back to Home</Button>
      </Link>
    </div>
  );
}
